'use es6';

import { getAdvancedModuleWithoutAccessError } from 'ContentEditorUI/redux/selectors/downgradeSelectors';
import { getDataValidationErrors } from 'ContentEditorUI/redux/selectors/moduleErrorSelectors';
import { getErrorLabels } from 'ContentEditorUI/utils/validationUtils';
import { createSelector } from 'reselect';
import { getPublishValidationErrors } from './postPublishSelectors';
import { getPostSettingsErrors, getPostSettingsWarnings } from './postSettingsErrorSelectors';
const getPostErrorsAndWarnings = createSelector([getDataValidationErrors, getPublishValidationErrors, getPostSettingsErrors, getAdvancedModuleWithoutAccessError, getPostSettingsWarnings], (moduleDataValidationErrors, publishErrors, settingsErrors, advancedModuleWithoutAccessErrors, settingsWarnings) => {
  return {
    errors: Object.assign({}, moduleDataValidationErrors, publishErrors, settingsErrors, advancedModuleWithoutAccessErrors),
    warnings: Object.assign({}, settingsWarnings)
  };
});
export const getPostErrorLabels = createSelector(getPostErrorsAndWarnings, ({
  errors
}) => getErrorLabels(errors));
export const getPostWarningLabels = createSelector(getPostErrorsAndWarnings, ({
  warnings
}) => getErrorLabels(warnings));